var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "identityRetrieval" },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": _vm.headShow,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c(
        "div",
        { staticClass: "formClass" },
        [
          _vm.active === 1
            ? _c(
                "van-form",
                {
                  staticClass: "identity-retrieval-one",
                  on: { submit: _vm.onSubmit }
                },
                [
                  _c("van-field", {
                    staticStyle: { "border-radius": "16px 16px 0 0" },
                    attrs: {
                      label: "真实姓名",
                      rules: _vm.rules.nameRules,
                      placeholder: "请输入姓名"
                    },
                    model: {
                      value: _vm.formParams.name,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "name", $$v)
                      },
                      expression: "formParams.name"
                    }
                  }),
                  _c("van-field", {
                    attrs: {
                      label: "身份证号码",
                      rules: _vm.rules.idRules,
                      placeholder: "请输入身份证号码"
                    },
                    model: {
                      value: _vm.formParams.idCard,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "idCard", $$v)
                      },
                      expression: "formParams.idCard"
                    }
                  }),
                  _c("van-field", {
                    attrs: {
                      label: "手机号",
                      rules: _vm.rules.mobileRules,
                      placeholder: "请输入能联系到您的手机号"
                    },
                    model: {
                      value: _vm.formParams.phoneNum,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "phoneNum", $$v)
                      },
                      expression: "formParams.phoneNum"
                    }
                  }),
                  _c("van-field", {
                    staticStyle: { "border-radius": "0 0 16px 16px" },
                    attrs: {
                      maxlength: "6",
                      label: "短信验证码",
                      rules: _vm.rules.codeRules,
                      placeholder: "请输入验证码"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "button",
                          fn: function() {
                            return [
                              !_vm.showTime
                                ? _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#616edf",
                                        cursor: "pointer"
                                      },
                                      on: { click: _vm.getCode }
                                    },
                                    [_vm._v(_vm._s(_vm.timeMsg))]
                                  )
                                : _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        color: "#878787",
                                        cursor: "pointer"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.codeTime) + " S")]
                                  )
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      895199067
                    ),
                    model: {
                      value: _vm.formParams.phoneCode,
                      callback: function($$v) {
                        _vm.$set(_vm.formParams, "phoneCode", $$v)
                      },
                      expression: "formParams.phoneCode"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        padding: "0.2rem 0.4rem",
                        width: "7rem",
                        color: "#878787"
                      }
                    },
                    [_vm._v(" *如果1分钟内没有收到验证码请重新获取 ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            type: "info",
                            color: "#616edf",
                            "native-type": "submit"
                          }
                        },
                        [_vm._v("下一步")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.active === 2
            ? _c("div", { staticClass: "identity-retrieval-two" }, [
                !_vm.bindPhoneListHide.length
                  ? _c("h5", [
                      _vm._v("亲爱的玩家，您当前的身份证未绑定雷霆账号。")
                    ])
                  : _c("h5", [
                      _vm._v(
                        _vm._s(
                          "亲爱的玩家，您当前的身份证绑定了" +
                            _vm.bindPhoneListHide.length +
                            "个雷霆账号："
                        )
                      )
                    ]),
                _c(
                  "ul",
                  [
                    _c("li", [_vm._v("雷霆账号")]),
                    _vm._l(_vm.bindPhoneListHide, function(item, i) {
                      return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "bottom" },
                  [
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          plain: "",
                          type: "info",
                          color: "#616edf"
                        },
                        on: { click: _vm.getFaceUrl }
                      },
                      [_vm._v("查看完整账号")]
                    )
                  ],
                  1
                ),
                _vm._m(0)
              ])
            : _vm._e(),
          !this.$isFlag && _vm.active === 3
            ? _c(
                "div",
                { staticClass: "identity-retrieval-three" },
                [
                  _vm._m(1),
                  _vm._m(2),
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        block: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: { click: _vm.checkFace }
                    },
                    [_vm._v("认证已完成")]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.active === 4
            ? _c("div", { staticClass: "identity-retrieval-four" }, [
                _c("h5", [
                  _vm._v(
                    _vm._s(
                      "亲爱的玩家，您当前的身份证绑定了" +
                        _vm.bindPhoneList.length +
                        "个雷霆账号："
                    )
                  )
                ]),
                _c(
                  "ul",
                  [
                    _c("li", [_vm._v("雷霆账号")]),
                    _vm._l(_vm.bindPhoneList, function(item, i) {
                      return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                    })
                  ],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "bottom" },
                  [
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          plain: "",
                          type: "info",
                          color: "#616edf"
                        },
                        on: {
                          click: function($event) {
                            _vm.active = 1
                          }
                        }
                      },
                      [_vm._v("查看完整账号")]
                    )
                  ],
                  1
                ),
                _vm._m(3)
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "identity-retrieval-two__tips" }, [
      _c("span", [_vm._v("温馨提示：")]),
      _c("p", [
        _vm._v(
          "1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。"
        )
      ]),
      _c("p", [_vm._v("2.若您已记起完整的账号，可以找回您的账号密码。")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "identity-retrieval-three__title" }, [
      _vm._v("请使用"),
      _c("span", [_vm._v("个人支付宝")]),
      _vm._v("，进行扫码验证")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "identity-retrieval-three__qrcode" }, [
      _c("canvas", { staticClass: "QR", attrs: { id: "canvas" } }),
      _c("p", [
        _c("span", [_vm._v("请勿将二维码转发给其他人，否则可能造成损失")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "identity-retrieval-two__tips" }, [
      _c("span", [_vm._v("温馨提示：")]),
      _c("p", [
        _vm._v(
          "1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。"
        )
      ]),
      _c("p", [_vm._v("2.若您已记起完整的账号，可以找回您的账号密码。")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }